













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,  TbSettingsPad,TbShop } from '@/http';
import { NumberKeyboard } from "@/components";
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'
@Component({ 
    components: {
        
    },
})
export default class zfSetting extends Vue {
   
    public $refs: {
    };

    //  登录信息
    loginInfo = {}
    form:any={
        
    };

    isLoading= false;

    //二维码
    QRCode = null
    qrcode = null
    QRCode1 = null
    qrcode1 = null
    isShow = false;

    created() {
        this.loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
    }

    async mounted(){
        let url = window.location.host.indexOf('test')>-1?'https://test-posm.hftopos.com/#/h5/h5login':'https://posm.hftopos.com/#/h5/h5login';
        console.log('url',url);
        // 支付审核状态
        let res = await TbShop.GetTbShopApproveInfoByShopNo();
        this.form = res;
        console.log('resss',this.form);
        if(this.form.alipayApproveStatus==0) {
            this.$nextTick(()=>{
                this.getEwm(url);
            })
        }
        if(this.form.approveStatus==0){
            this.$nextTick(()=>{
                this.getEwm1(url);
            })
        }
        if(res.approveStatus==0 || res.approveStatus) {
            console.log('cunzai');
            
        }else{
            this.isShow = true;
            console.log('bucunzai');
            this.$nextTick(()=>{
                this.getEwm(url);
                this.getEwm1(url);
            })
        }
        console.log('this.isShowthis.isShow',this.isShow);
        
    }
    //获取二维码
    getEwm(val){
        let qrCode = val;
        this.QRCode = qrCode;
        let qrcodeDiv = document.getElementById("SetQRCode")
        let qrcode = new QRCode(qrcodeDiv,{
            text:this.QRCode,//二维码中的内容
            width:150,
            height:150,
            colorDark:"#000",//二维码颜色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
            }) 
        this.qrcode = qrcode;
        let childs = document.getElementById("SetQRCode").childNodes;
        for(let i = childs.length -2 ; i>=0 ; i--){
            document.getElementById("SetQRCode").removeChild(childs[i]);
        }
    }
    getEwm1(val){
        let qrCode = val;
        this.QRCode1 = qrCode;
        let qrcodeDiv = document.getElementById("SetQRCode1")
        let qrcode = new QRCode(qrcodeDiv,{
            text:this.QRCode1,//二维码中的内容
            width:150,
            height:150,
            colorDark:"#000",//二维码颜色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
            }) 
        this.qrcode1 = qrcode;
        let childs = document.getElementById("SetQRCode1").childNodes;
        for(let i = childs.length -2 ; i>=0 ; i--){
            document.getElementById("SetQRCode1").removeChild(childs[i]);
        }
    }
    getStatusname(val,type){
        let str = '';
        switch (val) {
            case 0:
                str='尚未开通';
                break;
            case 1:
                str='平台审核中';
                break;
            case 2:
                str='平台审核中';
                break;
            case 3:
                if(type==1){
                    str=this.form.alipayShopName;
                }else{
                    str=this.form.weChatShopName;
                }
                break;
            case 5:
                if(type==1){
                    str=this.form.alipayShopName;
                }else{
                    str=this.form.weChatShopName;
                }
                break;
            default:
                str='尚未开通';
                break;
        }
        return str;
    }
    getRzname(val){
        let str = '';
        switch (val) {
            case 0:
                str='请使用手机扫码二维码，立即开通';
                break;
            case 1:
                str='认证资料已提交，请耐心等待';
                break;
            case 2:
                str='认证资料已提交，请耐心等待';
                break;
            default:
                str='请使用手机扫码二维码，立即开通';
                break;
        }
        return str;
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/zfSetting.vue